// libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

// constants
import { BREAKPOINTS, MWEB_HEADER_ZINDEX } from 'shared/styles/base';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const NudgeWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const Arrow = styled.span`
  position: absolute;
  top: -6px;
  right: 6px;
  width: 0;
  height: 0;
  border-left: ${({ theme }) => theme.spacing.spacing60} solid transparent;
  border-right: ${({ theme }) => theme.spacing.spacing60} solid transparent;
  border-bottom: ${({ theme }) => `${theme.spacing.spacing60} solid ${theme.colors.surfaceInverse}`};
`;

export const NudgeTooltip = styled.div`
  position: fixed;
  background: ${({ theme }) => theme.colors.surfaceInverse};
  color: ${({ theme }) => theme.colors.surface};
  ${({ theme }) => theme.typography.bodyMedium};
  padding: ${({ theme }) => theme.spacing.spacing60} ${({ theme }) => theme.spacing.spacing80};
  border-radius: ${({ theme }) => theme.borders.radius40};
  white-space: nowrap;
  z-index: ${MWEB_HEADER_ZINDEX};
  animation: ${fadeIn} 0.2s ease-out;
  margin-right: -${({ theme }) => theme.spacing.spacing20};

  @media (min-width: ${BREAKPOINTS.TABLET}px) {
    margin-right: ${({ theme }) => theme.spacing.spacing40};
    margin-top: ${({ theme }) => theme.spacing.spacing40};
  }
`;
